/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  ValidationError,
  VideoTrackingInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Video Tracking
 */
export const createVideoTracking = (
    videoTrackingInput: MaybeRefOrGetter<VideoTrackingInput>,
 signal?: AbortSignal
) => {
      videoTrackingInput = toValue(videoTrackingInput);

      return axiosClient<void>(
      {url: `/video_trackings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: videoTrackingInput, signal
    },
      );
    }




export const getCreateVideoTrackingMutationKey = () => ['createVideoTracking'] as const;

export const getCreateVideoTrackingMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoTracking>>, TError,CreateVideoTrackingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVideoTracking>>, TError,CreateVideoTrackingMutationVariables, TContext> => {

const mutationKey = getCreateVideoTrackingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVideoTracking>>, CreateVideoTrackingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createVideoTracking(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVideoTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof createVideoTracking>>>
    export type CreateVideoTrackingMutationBody = VideoTrackingInput
    export type CreateVideoTrackingMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateVideoTrackingMutationVariables = {data: VideoTrackingInput}

    /**
 * @summary Create Video Tracking
 */
export const useCreateVideoTracking = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoTracking>>, TError,CreateVideoTrackingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVideoTracking>>,
        TError,
        CreateVideoTrackingMutationVariables,
        TContext
      > => {
      return useMutation(getCreateVideoTrackingMutationOptions(options), queryClient);
    }
